<template>
  <!--Start Page Banner-->
  <div class="page-banner-area bg-1">
    <div class="container">
      <div class="page-banner-content">
        <h1>Metrics 2</h1>
        <ul>
          <li><a href="/">Home</a></li>
          <li>NAAC</li>
          <li>SSR Documents</li>
          <li>Criteria-wise Metrics 2</li>
        </ul>
      </div>
    </div>
  </div>
  <!--End Page Banner-->

  <!-- Start EI area -->
  <div class="alumni-area pt-100 pb-70">
    <div class="container">
      <div class="row">
        <div class="curriculum">
          <h3>I. Curricular Aspects</h3>
          <div class="curriculum-list">
            <ul>
              <li>
                1.1.1 The Institution ensures effective curriculum planning and
                delivery through a well-planned and documented process including
                the Academic calendar and the conduct of continuous internal
                Assessments.<span
                  ><a
                    target="_blank"
                    href="vf/documents/naac/14_SSR_Documents/02_matrix_2/01_criteria_1/1.1.1.pdf"
                    style="color: white"
                    >Documents</a
                  ></span
                >
              </li>
              <li>
                1.3.1 Institution integrates crosscutting issues relevant to
                Professional Ethics, Gender, Human Values, Environment and
                Sustainability into the Curriculum.<span
                  ><a
                    target="_blank"
                    href="vf/documents/naac/14_SSR_Documents/02_matrix_2/01_criteria_1/1.3.1.pdf"
                    style="color: white"
                    >Documents</a
                  ></span
                >
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="curriculum">
          <h3>II. Teaching, Learning and Evaluation</h3>
          <div class="curriculum-list">
            <ul>
              <li>
                2.2.1. Student – Full time Teacher Ratio.<span
                  ><a
                    target="_blank"
                    href="vf/documents/naac/14_SSR_Documents/02_matrix_2/02_criteria_2/2.2.1.pdf"
                    style="color: white"
                    >Documents</a
                  ></span
                >
              </li>
              <li>
                2.3.1. Student-centric methods, such as experiential learning,
                participative learning, and problem-solving methodologies are
                used for enhancing learning experiences using ICT tools.
                <span
                  ><a
                    target="_blank"
                    href="vf/documents/naac/14_SSR_Documents/02_matrix_2/02_criteria_2/2.3.1.pdf"
                    style="color: white"
                    >Documents</a
                  ></span
                >
              </li>
              <li>
                2.5.1. Mechanism of internal/ external assessment is transparent
                and the grievance redressal system is time-bound and efficient.
                <span
                  ><a
                    target="_blank"
                    href="vf/documents/naac/14_SSR_Documents/02_matrix_2/02_criteria_2/2.5.1.pdf"
                    style="color: white"
                    >Documents</a
                  ></span
                >
              </li>
              <li>
                2.6.1. Programme Outcomes (POs) and Course Outcomes (COs) for
                all Programmes offered by the institution are stated and
                displayed on the website.
                <span
                  ><a
                    target="_blank"
                    href="vf/documents/naac/14_SSR_Documents/02_matrix_2/02_criteria_2/2.6.1.pdf"
                    style="color: white"
                    >Documents</a
                  ></span
                >
              </li>
              <li>
                2.6.2 Attainment of POs and COs are evaluated.
                <span
                  ><a
                    target="_blank"
                    href="vf/documents/naac/14_SSR_Documents/02_matrix_2/02_criteria_2/2.6.2.pdf"
                    style="color: white"
                    >Documents</a
                  ></span
                >
              </li>
              <li>
                2.7.1 Online student satisfaction survey regarding teaching
                learning process.
                <span
                  ><a
                    target="_blank"
                    href="vf/documents/naac/14_SSR_Documents/02_matrix_2/02_criteria_2/2.7.1.pdf"
                    style="color: white"
                    >Documents</a
                  ></span
                >
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="curriculum">
          <h3>III. Research, Innovation & Extension</h3>
          <div class="curriculum-list">
            <ul>
              <li>
                3.2.1 Institution has created an ecosystem for innovations and
                has initiatives for the creation and transfer of knowledge.<span
                  ><a
                    target="_blank"
                    href="vf/documents/naac/14_SSR_Documents/02_matrix_2/03_criteria_3/3.2.1.pdf"
                    style="color: white"
                    >Documents</a
                  ></span
                >
              </li>
              <li>
                3.4.1. Extension activities are carried out in the neighborhood
                community, sensitizing students to social issues, for their
                holistic development, and impact thereof during the last five
                years.<span
                  ><a
                    target="_blank"
                    href="vf/documents/naac/14_SSR_Documents/02_matrix_2/03_criteria_3/3.4.1.pdf"
                    style="color: white"
                    >Documents</a
                  ></span
                >
              </li>
              <li>
                3.4.2 Awards and recognitions received for extension activities
                from government/government recognized bodies.<span
                  ><a
                    target="_blank"
                    href="vf/documents/naac/14_SSR_Documents/02_matrix_2/03_criteria_3/3.4.2.pdf"
                    style="color: white"
                    >Documents</a
                  ></span
                >
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="curriculum">
          <h3>IV. Infrastructure & Learning Resources</h3>
          <div class="curriculum-list">
            <ul>
              <li>
                4.1.1. Availability of adequate infrastructure and physical
                facilities viz., classrooms, laboratories, ICT facilities,
                cultural activities, gymnasium, yoga Centre, etc. in the
                institution.
                <span
                  ><a
                    target="_blank"
                    href="vf/documents/naac/14_SSR_Documents/02_matrix_2/04_criteria_4/4.1.1.pdf"
                    style="color: white"
                    >Documents</a
                  ></span
                >
              </li>
              <li>
                4.2.1. Library is automated using an Integrated Library
                Management System (ILMS), subscription to e-resources, the
                amount spent on the purchase of books, journals, and per day
                usage of the library
                <span
                  ><a
                    target="_blank"
                    href="vf/documents/naac/14_SSR_Documents/02_matrix_2/04_criteria_4/4.2.1.pdf"
                    style="color: white"
                    >Documents</a
                  ></span
                >
              </li>
              <li>
                4.3.1. Institution frequently updates its IT facilities and
                provides sufficient bandwidth for internet connection
                <span
                  ><a
                    target="_blank"
                    href="vf/documents/naac/14_SSR_Documents/02_matrix_2/04_criteria_4/4.3.1.pdf"
                    style="color: white"
                    >Documents</a
                  ></span
                >
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="curriculum">
          <h3>V. Student Support & Progression</h3>
          <div class="curriculum-list">
            <ul>
              <li>
                5.4.1 There is a registered Alumni Association that contributes
                significantly to the development of the institution through
                financial and/or other support services.
                <span
                  ><a
                    target="_blank"
                    href="vf/documents/naac/14_SSR_Documents/02_matrix_2/05_criteria_5/5.4.1.pdf"
                    style="color: white"
                    >Documents</a
                  ></span
                >
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="curriculum">
          <h3>VI. Governance, Leadership & Management</h3>
          <div class="curriculum-list">
            <ul>
              <li>
                6.1.1 The governance and leadership are in accordance with the
                vision and mission of the institution and it is visible in
                various institutional practices such as decentralization and
                participation in institutional governance.
                <span
                  ><a
                    target="_blank"
                    href="vf/documents/naac/14_SSR_Documents/02_matrix_2/06_criteria_6/6.1.1.pdf"
                    style="color: white"
                    >Documents</a
                  ></span
                >
              </li>
              <li>
                6.2.1 The functioning of the institutional bodies is effective
                and efficient as visible from policies, administrative setup,
                appointment and service rules, procedures, deployment of
                institutional Strategic/ perspective/development plan etc.
                <span
                  ><a
                    target="_blank"
                    href="vf/documents/naac/14_SSR_Documents/02_matrix_2/06_criteria_6/6.2.1.pdf"
                    style="color: white"
                    >Documents</a
                  ></span
                >
              </li>
              <li>
                6.3.1 The institution has effective welfare measures and a
                Performance Appraisal System for teaching and non-teaching
                staff.
                <span
                  ><a
                    target="_blank"
                    href="vf/documents/naac/14_SSR_Documents/02_matrix_2/06_criteria_6/6.3.1.pdf"
                    style="color: white"
                    >Documents</a
                  ></span
                >
              </li>
              <li>
                6.4.1 Institution has strategies for mobilization and optimal
                utilization of resources and funds from various sources
                (government/ non government organizations) and it conducts
                financial audits regularly (internal and external).
                <span
                  ><a
                    target="_blank"
                    href="vf/documents/naac/14_SSR_Documents/02_matrix_2/06_criteria_6/6.4.1.pdf"
                    style="color: white"
                    >Documents</a
                  ></span
                >
              </li>
              <li>
                6.5.1 Internal Quality Assurance Cell (IQAC) has contributed
                significantly for institutionalizing the quality assurance
                strategies and processes. It reviews teaching learning
                processes, structures & methodologies of operations and learning
                outcomes at periodic intervals and records the incremental
                improvement in various activities.
                <span
                  ><a
                    target="_blank"
                    href="vf/documents/naac/14_SSR_Documents/02_matrix_2/06_criteria_6/6.5.1.pdf"
                    style="color: white"
                    >Documents</a
                  ></span
                >
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="curriculum">
          <h3>VII. Institutional Values & Best Practices</h3>
          <div class="curriculum-list">
            <ul>
              <li>
                7.1.1 Measures initiated by the Institution for the promotion of
                gender equity and Institutional initiatives to celebrate /
                organize national and international commemorative days, events
                and festivals during the last five years.
                <span
                  ><a
                    target="_blank"
                    href="vf/documents/naac/14_SSR_Documents/02_matrix_2/07_criteria_7/7.1.1.pdf"
                    style="color: white"
                    >Documents</a
                  ></span
                >
              </li>
              <li>
                7.1.4 Describe the Institutional efforts/initiatives in
                providing an inclusive environment i.e., tolerance and harmony
                towards cultural, regional, linguistic, communal socioeconomic
                and Sensitization of students and employees to the
                constitutional obligations: values, rights, duties and
                responsibilities of citizens.
                <span
                  ><a
                    target="_blank"
                    href="vf/documents/naac/14_SSR_Documents/02_matrix_2/07_criteria_7/7.1.4.pdf"
                    style="color: white"
                    >Documents</a
                  ></span
                >
              </li>
              <li>
                7.2.1 Describe two best practices successfully implemented by
                the Institution as per NAAC format provided in the Manual
                <span
                  ><a
                    target="_blank"
                    href="vf/documents/naac/14_SSR_Documents/02_matrix_2/07_criteria_7/7.2.1.pdf"
                    style="color: white"
                    >Documents</a
                  ></span
                >
              </li>
              <li>
                7.3.1 Portray the performance of the Institution in one area
                distinctive to its priority and thrust
                <span
                  ><a
                    target="_blank"
                    href="vf/documents/naac/14_SSR_Documents/02_matrix_2/07_criteria_7/7.3.1.pdf"
                    style="color: white"
                    >Documents</a
                  ></span
                >
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- End EI area -->

  <!-- Start Bottom Connect Area -->
  <div class="alumni-interview-area pb-100">
    <div class="container">
      <div class="interview-content ptb-100">
        <div class="interview">
          <a href="/newsletter" class="default-btn btn"
            >Newsletter<i class="flaticon-next"></i
          ></a>
          <router-link to="/applynow" class="default-btn btn"
            >Apply Now</router-link
          >
        </div>
      </div>
    </div>
  </div>
  <!--End Bottom Connect Area -->
</template>

<script>
export default {
  name: "ssrd-criteria2",
};
</script>
